<template>
  <transition name="fade">
    <div v-if="show" class="portal-modal" @click="handleClick">
      <slot name="portal-panel"></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    canClick: {
      type: Boolean,
      default: true
    },
    canTouch: {
      // 需要能够滚动
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    close() {
      this.show = false
    },
    open() {
      this.show = true
    },
    handleClick(e) {
      const fromMask = e.target.className === 'portal-modal'
      if (fromMask && this.canClick) {
        this.close()
      }

      // 弹窗需要可以滚动
      if (!this.canTouch || fromMask) {
        e.preventDefault()
        e.stopImmediatePropagation()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.portal-modal {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1000;

  background: rgba(0, 0, 0, 0.6);
}
</style>
